import React  from "react";

// reactstrap components
import {
  Container,
  Row,
} from "reactstrap";


export default function Setup() {
  
  return (
    <>
      <div className="header bg-gradient-success pb-8 pt-5 pt-md-8">
        <Container fluid>
          <div className="header-body">
            <Row>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
}